import { createFileRoute } from "@tanstack/react-router";
import PartsCatalogManufacturer from "@/pages/PartsCatalogManufacturer";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/parts-catalog/manufacturer/$slug")({
  head: ({ params }) => {
    const name = params.slug.replace(/-/g, ' ');
    return pageHead({ title: `${name} Brand Parts`, description: `Shop ${name} RV parts and accessories at Rex & Sons RVs.`, path: `/parts-catalog/manufacturer/${params.slug}` });
  },
  component: PartsCatalogManufacturer,
});
